"use strict";var e=require("../Guard/isNonNullObject.cjs");exports.isReactElement=function(t){return e.isNonNullObject(t)&&"$$typeof"in t};
//# sourceMappingURL=isReactElement.cjs.map
